const data = {
  amapKey: '12af733009e96a2984bddbc7794d8df5',
  amapStyle: 'amap://styles/67eda29fb0674f82c213688e2b9e9a2e',
  dealStatus: ['全部', '待支付', '待采血', '待送检', '已送检', '检测中', '已完成', '', '已退款', '已取消'],
  payStatus: ['待支付', '支付中', '已支付', '待退款', '退款中', '已退款', '退款失败'],
  shareStatus: ['全部', '待分帐', '分帐中', '已分帐', '已退回', '失败', '未知'],
  articleStatus: ['全部', '草稿箱', '待审核', '已审核', '已拒审'],
  products: [{
    name: '二价',
    price: 499,
    ratio: 50
  }, {
    name: '四价',
    price: 699,
    ratio: 50
  }, {
    name: '九价',
    price: 999,
    ratio: 50
  }],
  payTypes: ['默认', '线下', '线上'],
  genders: ['未知', '男', '女'],
  pointStatus: ['正常', '停用']
}
export default {
  data
}



// WEBPACK FOOTER //
// ./src/utils/config.js